// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__shwZW","rootMobile":"styles_rootMobile__1S7E1"};